export var cellSelectionNodesBetween = function cellSelectionNodesBetween(selection, doc, f, startPos
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/max-params
) {
  selection.forEachCell(function (cell, cellPos) {
    doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
  });
};